<template>
  <div :class="windowWidth ? 'mainSideBarDiv' : 'mainSideBarMobile'">
    <v-navigation-drawer
      v-if="windowWidth"
      :width="!mini ? '800' : '69'"
      permanent
      class="white-sidebar"
    >
      <div>
        <v-divider></v-divider>
        <v-list-item
          two-line
          class="mt-2"
          :class="
            watchActiveItem == 'home' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('home')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-4' : 'ml-4 mt-4'"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.7319 6.49L9.00356 0.659668L1.26809 6.49C1.10817 6.63755 1.01201 6.84157 1 7.05881V15.9622C1.00056 16.1464 1.07402 16.323 1.20432 16.4532C1.33462 16.5835 1.51119 16.657 1.69547 16.6575H6.33333V12.9268C6.33333 12.2197 6.61429 11.5415 7.11438 11.0415C7.61448 10.5414 8.29276 10.2605 9 10.2605C9.70724 10.2605 10.3855 10.5414 10.8856 11.0415C11.3857 11.5415 11.6667 12.2197 11.6667 12.9268V16.6597H16.3038C16.4882 16.6591 16.6648 16.5857 16.7952 16.4554C16.9256 16.3252 16.9993 16.1486 17 15.9643V7.05881C16.9877 6.84165 16.8916 6.63773 16.7319 6.49Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Home
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          two-line
          :class="
            watchActiveItem == 'care' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('care')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-4' : 'ml-4 mt-4'"
            @click="dialog = true"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 9.72494C1 12.0522 1.94821 14.2842 3.63604 15.9298C5.32387 17.5754 7.61305 18.4999 10 18.4999C12.3869 18.4999 14.6761 17.5754 16.364 15.9298C18.0518 14.2842 19 12.0522 19 9.72494C19 7.39767 18.0518 5.16572 16.364 3.52009C14.6761 1.87446 12.3869 0.949951 10 0.949951C7.61305 0.949951 5.32387 1.87446 3.63604 3.52009C1.94821 5.16572 1 7.39767 1 9.72494V9.72494Z"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.80078 9.04236C5.80078 9.9474 6.16953 10.8154 6.82591 11.4553C7.48228 12.0953 8.37252 12.4548 9.30078 12.4548C10.229 12.4548 11.1193 12.0953 11.7757 11.4553C12.432 10.8154 12.8008 9.9474 12.8008 9.04236C12.8008 8.13731 12.432 7.26934 11.7757 6.62937C11.1193 5.98941 10.229 5.62988 9.30078 5.62988C8.37252 5.62988 7.48228 5.98941 6.82591 6.62937C6.16953 7.26934 5.80078 8.13731 5.80078 9.04236V9.04236Z"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.7754 11.4551L14.2002 13.82"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Care
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'connect' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('connect')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-4' : 'ml-4 mt-4'"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.7998 11.24V7.32002H6.3598C6.73086 7.32533 7.09926 7.25682 7.44361 7.11848C7.78795 6.98014 8.10136 6.77473 8.36561 6.5142C8.62987 6.25367 8.8397 5.9432 8.98291 5.60086C9.12611 5.25851 9.19984 4.89112 9.1998 4.52002C9.1998 4.22298 9.3178 3.93811 9.52785 3.72806C9.73789 3.51802 10.0228 3.40002 10.3198 3.40002C10.7229 3.40002 11.1096 3.56017 11.3946 3.84522C11.6797 4.13028 11.8398 4.5169 11.8398 4.92002V5.64002C11.8398 5.96802 12.0558 6.20002 12.5598 6.20002C12.7946 6.19997 13.0269 6.24914 13.2415 6.34436C13.4562 6.43959 13.6485 6.57876 13.806 6.75289C13.9636 6.92702 14.0828 7.13225 14.1562 7.35532C14.2295 7.5784 14.2553 7.81438 14.2318 8.04802L13.9998 9.78402C13.9444 10.3357 13.6863 10.8473 13.2754 11.2197C12.8646 11.5921 12.3303 11.7988 11.7758 11.8H9.4558C8.7813 11.7335 8.11912 11.5746 7.4878 11.328C7.28742 11.2709 7.08018 11.2413 6.8718 11.24H5.7998Z"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.8 15.4H9.4L4.6 19V15.4H2.2C1.88174 15.4 1.57652 15.2736 1.35147 15.0485C1.12643 14.8235 1 14.5183 1 14.2V2.2C1 1.88174 1.12643 1.57652 1.35147 1.35147C1.57652 1.12643 1.88174 1 2.2 1H17.8C18.1183 1 18.4235 1.12643 18.6485 1.35147C18.8736 1.57652 19 1.88174 19 2.2V14.2C19 14.5183 18.8736 14.8235 18.6485 15.0485C18.4235 15.2736 18.1183 15.4 17.8 15.4Z"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Connect
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item
          two-line
          :class="
            watchActiveItem == 'passes' ? 'pointer active' : 'passes inactive'
          "
          @click="activeItem('passes')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-4' : 'ml-4 mt-4'"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.39961 12.4L7.73801 11.396C7.87462 11.2937 8.03065 11.2203 8.19657 11.1803C8.3625 11.1403 8.53483 11.1345 8.70306 11.1634C8.87129 11.1922 9.03187 11.255 9.17502 11.348C9.31816 11.4409 9.44085 11.5621 9.53561 11.704V11.704C9.67296 11.9102 9.74625 12.1523 9.74625 12.4C9.74625 12.6477 9.67296 12.8899 9.53561 13.096L8.21961 15.0696C7.81522 15.6758 7.23638 16.145 6.55961 16.4152L4.59961 17.2"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 8.20001L4.124 9.43281C3.27413 9.79696 2.59695 10.4741 2.2328 11.324L1.2912 13.52C1.09896 13.9685 0.999891 14.4513 1 14.9392V19"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 16.204V17.2C7 17.6774 7.18964 18.1352 7.52721 18.4728C7.86477 18.8104 8.32261 19 8.8 19H17.2C17.6774 19 18.1352 18.8104 18.4728 18.4728C18.8104 18.1352 19 17.6774 19 17.2V2.8C19 2.32261 18.8104 1.86477 18.4728 1.52721C18.1352 1.18964 17.6774 1 17.2 1H15.4C15.4 1.63652 15.1471 2.24697 14.6971 2.69706C14.247 3.14714 13.6365 3.4 13 3.4C12.3635 3.4 11.753 3.14714 11.3029 2.69706C10.8529 2.24697 10.6 1.63652 10.6 1H8.8C8.32261 1 7.86477 1.18964 7.52721 1.52721C7.18964 1.86477 7 2.32261 7 2.8V11.9504"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.40039 6.40002H16.6004"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16 8.79999V16.6"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.7996 13C12.0916 12.9997 12.3792 13.0704 12.6377 13.2061C12.8963 13.3417 13.1179 13.5382 13.2836 13.7786C13.4493 14.019 13.554 14.2961 13.5887 14.586C13.6234 14.8759 13.5871 15.1699 13.4828 15.4426C13.3786 15.7153 13.2096 15.9586 12.9904 16.1514C12.7712 16.3443 12.5084 16.4809 12.2246 16.5495C11.9409 16.6182 11.6447 16.6168 11.3616 16.5454C11.0785 16.4741 10.817 16.3349 10.5996 16.14"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Passes
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'profile' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('profile')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-4' : 'ml-4 mt-4'"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 17 17"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="gray"
                d="M4.46094 4.28751C4.46094 5.19256 4.88642 6.06054 5.64377 6.70051C6.40113 7.34048 7.42833 7.70001 8.49939 7.70001C9.57045 7.70001 10.5977 7.34048 11.355 6.70051C12.1124 6.06054 12.5378 5.19256 12.5378 4.28751C12.5378 3.38245 12.1124 2.51447 11.355 1.8745C10.5977 1.23453 9.57045 0.875 8.49939 0.875C7.42833 0.875 6.40113 1.23453 5.64377 1.8745C4.88642 2.51447 4.46094 3.38245 4.46094 4.28751V4.28751Z"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                fill="gray"
                d="M1 15.5002C1 13.8194 1.79018 12.2074 3.1967 11.0188C4.60323 9.83031 6.51089 9.1626 8.50002 9.1626C10.4891 9.1626 12.3968 9.83031 13.8033 11.0188C15.2099 12.2074 16 13.8194 16 15.5002"
                stroke="gray"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Profile
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
      <div>
        <v-divider></v-divider>
        <v-list-item two-line v-if="!mini" class="mb-2">
          <span class="orange--text mt-1 ml-1" style="font-size: 9px">
            Powered by:
          </span>

          <v-list-item-content
            class="no-padding pointer justify-center mt-2 mb-2"
          >
            <v-list-item-title
              class="d-flex mb-3 align-center text-center text-gray-darker"
            >
              <img src="/apalyhealthlogo.png" alt="" class="mt-1 ml-1" />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item two-line v-else class="mt-4">
          <v-list-item-content class="no-padding pointer">
            <v-list-item-title
              class="d-flex mb-3 align-center text-center text-gray-darker"
            >
              <img
                src="/apaly1.png"
                class="ml-1"
                width="95"
                height="45"
                alt=""
              />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-navigation-drawer>

    <!-- Mobile -->
    <!--        <v-navigation-drawer v-else permanent class="white-sidebar-onmobile" >-->
    <!--            <v-divider></v-divider>-->
    <!--                <v-list-item two-line :class="item == 'home' ? 'pointer active' : 'pointer'"   @click="activeItem('home')">-->
    <!--                    <v-list-item-icon class="list-item-icon no-padding">-->
    <!--                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
    <!--                            <path d="M16.7319 6.49L9.00356 0.659668L1.26809 6.49C1.10817 6.63755 1.01201 6.84157 1 7.05881V15.9622C1.00056 16.1464 1.07402 16.323 1.20432 16.4532C1.33462 16.5835 1.51119 16.657 1.69547 16.6575H6.33333V12.9268C6.33333 12.2197 6.61429 11.5415 7.11438 11.0415C7.61448 10.5414 8.29276 10.2605 9 10.2605C9.70724 10.2605 10.3855 10.5414 10.8856 11.0415C11.3857 11.5415 11.6667 12.2197 11.6667 12.9268V16.6597H16.3038C16.4882 16.6591 16.6648 16.5857 16.7952 16.4554C16.9256 16.3252 16.9993 16.1486 17 15.9643V7.05881C16.9877 6.84165 16.8916 6.63773 16.7319 6.49Z" stroke="#707070" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        </svg>-->
    <!--                    </v-list-item-icon>-->
    <!--                    <v-list-item-content class="no-padding">-->
    <!--                        <v-list-item-title  class="d-flex mb-3 align-center font text-gray">-->
    <!--                            Home-->
    <!--                        </v-list-item-title>-->
    <!--                    </v-list-item-content>-->
    <!--                </v-list-item>-->
    <!--                <v-list-item two-line :class="item == 'members' ? 'pointer active' : 'pointer'"   @click="activeItem('members')">-->
    <!--                    <v-list-item-icon class="list-item-icon no-padding">-->
    <!--                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
    <!--                            <path d="M12.2002 3.46152C12.2002 4.11436 12.425 4.74046 12.825 5.20208C13.2251 5.66371 13.7677 5.92305 14.3335 5.92305C14.8993 5.92305 15.4419 5.66371 15.842 5.20208C16.2421 4.74046 16.4669 4.11436 16.4669 3.46152C16.4669 2.80869 16.2421 2.18259 15.842 1.72096C15.4419 1.25934 14.8993 1 14.3335 1C13.7677 1 13.2251 1.25934 12.825 1.72096C12.425 2.18259 12.2002 2.80869 12.2002 3.46152V3.46152Z" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M13.133 15.7692L13.2667 17H15.4001L15.9334 12.0769H17.0001V10.2307C17.0001 9.65932 16.8622 9.09918 16.6018 8.6131C16.3414 8.12702 15.9689 7.7342 15.526 7.47865C15.083 7.2231 14.5871 7.11493 14.0939 7.16624C13.6007 7.21756 13.1296 7.42634 12.7334 7.7692" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M1.5332 3.46152C1.5332 4.11436 1.75796 4.74046 2.15804 5.20208C2.55812 5.66371 3.10074 5.92305 3.66654 5.92305C4.23233 5.92305 4.77495 5.66371 5.17503 5.20208C5.57511 4.74046 5.79987 4.11436 5.79987 3.46152C5.79987 2.80869 5.57511 2.18259 5.17503 1.72096C4.77495 1.25934 4.23233 1 3.66654 1C3.10074 1 2.55812 1.25934 2.15804 1.72096C1.75796 2.18259 1.5332 2.80869 1.5332 3.46152V3.46152Z" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M4.86702 15.7692L4.73333 17H2.6L2.06667 12.0769H1V10.2307C1 9.65932 1.13791 9.09918 1.39826 8.6131C1.65862 8.12702 2.03115 7.7342 2.4741 7.47865C2.91704 7.2231 3.41292 7.11493 3.90615 7.16624C4.39938 7.21756 4.87048 7.42634 5.26666 7.7692" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M7.3999 6.53842C7.3999 7.02805 7.56847 7.49762 7.86853 7.84384C8.16859 8.19006 8.57556 8.38457 8.9999 8.38457C9.42425 8.38457 9.83122 8.19006 10.1313 7.84384C10.4313 7.49762 10.5999 7.02805 10.5999 6.53842C10.5999 6.04878 10.4313 5.57921 10.1313 5.23299C9.83122 4.88677 9.42425 4.69226 8.9999 4.69226C8.57556 4.69226 8.16859 4.88677 7.86853 5.23299C7.56847 5.57921 7.3999 6.04878 7.3999 6.53842V6.53842Z" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M8.99967 9.61536C8.29243 9.61536 7.61415 9.93953 7.11406 10.5166C6.61396 11.0936 6.33301 11.8762 6.33301 12.6923V13.3077H7.39967L7.93301 17H8.99967" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M9 9.61536C9.70724 9.61536 10.3855 9.93953 10.8856 10.5166C11.3857 11.0936 11.6667 11.8762 11.6667 12.6923V13.3077H10.6L10.0667 17H9" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        </svg>-->

    <!--                    </v-list-item-icon>-->
    <!--                    <v-list-item-content class="no-padding">-->
    <!--                        <v-list-item-title  class="d-flex mb-3 align-center font text-gray ">-->
    <!--                            My Family-->
    <!--                        </v-list-item-title>-->
    <!--                    </v-list-item-content>-->
    <!--                </v-list-item>-->
    <!--                <v-list-item two-line :class="item == 'prior' ? 'pointer active' : 'pointer'"   @click="activeItem('prior')">-->
    <!--                    <v-list-item-icon class="list-item-icon no-padding">-->
    <!--                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">-->
    <!--                            <path d="M1.5 2.67383L2.7 4.1877V7.76193C2.668 9.11257 4.2336 10.3224 5.6992 11.5642" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M5.0846 6.78734L6.4998 8.2372C6.5891 8.32888 6.69558 8.40207 6.81315 8.45259C6.93073 8.50311 7.05711 8.52997 7.18507 8.53164C7.31303 8.53331 7.44006 8.50976 7.55892 8.46233C7.67778 8.4149 7.78614 8.34452 7.8778 8.2552C7.96946 8.16589 8.04264 8.05939 8.09315 7.94179C8.14366 7.82419 8.17052 7.69779 8.17219 7.56981C8.17386 7.44182 8.15031 7.31477 8.10289 7.19589C8.05547 7.07701 7.9851 6.96863 7.8958 6.87696L5.695 4.63096V3.46035C5.57577 2.7589 5.30909 2.09074 4.9126 1.5" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M5.7002 7.41138V17.1027C5.7002 17.421 5.82662 17.7263 6.05167 17.9514C6.27671 18.1765 6.58194 18.3029 6.9002 18.3029H12.9002" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M19.5001 18.3287L18.3001 16.8148V13.2414C18.3281 12.074 17.1633 11.0122 15.9001 9.94482V14.2L14.5001 12.7661C14.3198 12.581 14.0733 12.4751 13.8148 12.4717C13.5564 12.4683 13.3072 12.5677 13.1221 12.7481C12.937 12.9285 12.8311 13.175 12.8277 13.4335C12.8243 13.692 12.9238 13.9412 13.1041 14.1264L15.3081 16.3732V17.543C15.4279 18.2433 15.6946 18.9103 16.0905 19.5001" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M11.2825 15.3025H8.1001" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M9.3001 12.302H8.1001" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M17.0999 5.10064C17.0999 5.81278 16.8888 6.50893 16.4932 7.10105C16.0976 7.69317 15.5354 8.15467 14.8776 8.4272C14.2197 8.69972 13.4959 8.77103 12.7976 8.6321C12.0992 8.49316 11.4578 8.15024 10.9543 7.64668C10.4509 7.14312 10.108 6.50155 9.96908 5.80309C9.83017 5.10463 9.90146 4.38067 10.1739 3.72273C10.4464 3.0648 10.9078 2.50246 11.4999 2.10682C12.0919 1.71117 12.7879 1.5 13.4999 1.5" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M17.1001 2.39941L13.8201 5.68C13.7782 5.72219 13.7283 5.75567 13.6734 5.77852C13.6185 5.80137 13.5596 5.81313 13.5001 5.81313C13.4406 5.81313 13.3818 5.80137 13.3268 5.77852C13.2719 5.75567 13.2221 5.72219 13.1801 5.68L12.1489 4.64781" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        </svg>-->
    <!--                    </v-list-item-icon>-->
    <!--                    <v-list-item-content class="no-padding">-->
    <!--                        <v-list-item-title  class="d-flex mb-3 align-center font text-gray ">-->
    <!--                            My Prior Auths-->
    <!--                        </v-list-item-title>-->
    <!--                    </v-list-item-content>-->
    <!--                </v-list-item>-->
    <!--                <v-list-item two-line :class="item == 'providers' ? 'pointer active' : 'pointer'"   @click="activeItem('providers')">-->
    <!--                    <v-list-item-icon class="list-item-icon no-padding">-->
    <!--                   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">-->
    <!--                        <path d="M14.1707 1H3.39468C2.75957 1 2.15047 1.25286 1.70139 1.70294C1.2523 2.15303 1 2.76348 1 3.4V17.8C1 18.1183 1.12615 18.4235 1.35069 18.6485C1.57524 18.8736 1.87979 19 2.19734 19H3.3388" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M3.39453 4.80005H9.18167" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M3.39453 8H7.27391" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M12.375 8.2V2.8C12.375 2.32261 12.5642 1.86477 12.901 1.52721C13.2379 1.18964 13.6947 1 14.171 1V1C14.6473 1 15.1042 1.18964 15.441 1.52721C15.7778 1.86477 15.967 2.32261 15.967 2.8V4.8H12.375" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M17.763 16.0881L13.9395 16.8561" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M14.3215 12.5121L12.5175 13.2721C12.3764 13.3333 12.2243 13.3649 12.0705 13.3649C11.9167 13.3649 11.7646 13.3333 11.6235 13.2721C11.4152 13.1775 11.2379 13.0258 11.1119 12.8346C10.9859 12.6433 10.9164 12.4203 10.9114 12.1912C10.9064 11.9621 10.9661 11.7362 11.0836 11.5396C11.2011 11.343 11.3717 11.1837 11.5756 11.0801L13.3796 10.1761C13.602 10.0619 13.8481 10.0016 14.098 10.0001C14.2866 9.99817 14.4738 10.0335 14.6488 10.1041L18.3366 11.6001" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M6.94629 16.8881H8.21547L10.6501 18.7441C10.7071 18.8089 10.7763 18.8617 10.8538 18.8996C10.9312 18.9375 11.0154 18.9597 11.1014 18.9649C11.1875 18.9701 11.2737 18.9582 11.3551 18.93C11.4365 18.9017 11.5116 18.8576 11.576 18.8001L14.9764 15.9841C15.1122 15.8743 15.1992 15.7152 15.2186 15.5415C15.238 15.3678 15.1883 15.1934 15.0802 15.0561L13.1725 12.9841" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M11.3686 11.2082L11.1691 11.0402C10.9183 10.875 10.6229 10.7912 10.323 10.8002C10.1404 10.8002 9.95933 10.8327 9.78814 10.8962L6.93848 12.0802" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M5.78906 17.4882H6.02853C6.14807 17.4946 6.26771 17.4774 6.38059 17.4375C6.49347 17.3975 6.59738 17.3356 6.68636 17.2554C6.77534 17.1751 6.84765 17.0781 6.89913 16.9697C6.95062 16.8614 6.98028 16.744 6.9864 16.6242V12.3442C6.97199 12.1036 6.86315 11.8785 6.68367 11.7181C6.50418 11.5577 6.26865 11.4751 6.02853 11.4882H5.78906" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M18.9602 17.4882H18.7606C18.6411 17.4946 18.5214 17.4774 18.4085 17.4375C18.2957 17.3975 18.1918 17.3356 18.1028 17.2554C18.0138 17.1751 17.9415 17.0781 17.89 16.9697C17.8385 16.8614 17.8089 16.744 17.8027 16.6242V12.3442C17.8171 12.1036 17.926 11.8785 18.1055 11.7181C18.285 11.5577 18.5205 11.4751 18.7606 11.4882H19.0001" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                    </svg>-->

    <!--                    </v-list-item-icon>-->
    <!--                    <v-list-item-content class="no-padding">-->
    <!--                        <v-list-item-title  class="d-flex mb-3 align-center font text-gray ">-->
    <!--                            My Visit Passess-->
    <!--                        </v-list-item-title>-->
    <!--                    </v-list-item-content>-->
    <!--                </v-list-item>-->
    <!--                <v-list-item two-line :class="item == 'advisors' ? 'pointer active' : 'pointer'"   @click="activeItem('advisors')">-->
    <!--                    <v-list-item-icon class="list-item-icon no-padding">-->
    <!--                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">-->
    <!--                        <path d="M14.2002 11.8C15.6217 12.3923 16.836 13.3921 17.6902 14.6734C18.5444 15.9547 19.0002 17.4601 19.0002 19" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M3.40039 18.9999C3.40331 17.953 3.61736 16.9175 4.02974 15.9553C4.44211 14.9931 5.04434 14.124 5.80039 13.3999" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M14.2002 10.6001V12.4001C14.2002 13.1957 13.8841 13.9588 13.3215 14.5214C12.7589 15.084 11.9958 15.4001 11.2002 15.4001C10.4045 15.4001 9.64148 15.084 9.07887 14.5214C8.51627 13.9588 8.2002 13.1957 8.2002 12.4001V10.6001" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M2.6 9.80009C3.48366 9.80009 4.2 9.08375 4.2 8.2001C4.2 7.31644 3.48366 6.6001 2.6 6.6001C1.71634 6.6001 1 7.31644 1 8.2001C1 9.08375 1.71634 9.80009 2.6 9.80009Z" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M4.19238 8.33594C4.66051 8.50144 5.06578 8.80807 5.35234 9.21355C5.6389 9.61903 5.79264 10.1034 5.79238 10.5999V17.1999C5.79238 17.437 5.8392 17.6717 5.93016 17.8906C6.02112 18.1095 6.15442 18.3083 6.32242 18.4756C6.49041 18.6428 6.68979 18.7752 6.9091 18.8652C7.12841 18.9552 7.36333 19.001 7.60038 18.9999H9.40038C9.87777 18.9999 10.3356 18.8103 10.6732 18.4727C11.0107 18.1352 11.2004 17.6773 11.2004 17.1999V15.3999" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M11.2 9.39999C13.5196 9.39999 15.4 7.51959 15.4 5.2C15.4 2.8804 13.5196 1 11.2 1C8.8804 1 7 2.8804 7 5.2C7 7.51959 8.8804 9.39999 11.2 9.39999Z" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                        <path d="M7.59961 3.06396C8.24732 3.73694 9.02373 4.27283 9.88267 4.63977C10.7416 5.00671 11.6656 5.19722 12.5996 5.19996C13.5489 5.20262 14.4885 5.00925 15.3596 4.63196" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                    </svg>-->

    <!--                    </v-list-item-icon>-->
    <!--                    <v-list-item-content class="no-padding">-->
    <!--                        <v-list-item-title  class="d-flex mb-3 align-center font text-gray ">-->
    <!--                            My Providers-->
    <!--                        </v-list-item-title>-->
    <!--                    </v-list-item-content>-->
    <!--                </v-list-item>-->
    <!--                <v-list-item two-line :class="item == 'contract' ? 'pointer active' : 'pointer'"   @click="activeItem('contract')">-->
    <!--                    <v-list-item-icon class="list-item-icon no-padding">-->
    <!--                      <svg width="18" height="18" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">-->
    <!--                            <path d="M15.7682 4.67723L8.9663 0.905098C8.82049 0.824358 8.65875 0.782227 8.49464 0.782227C8.33052 0.782227 8.16879 0.824358 8.02297 0.905098L1.22244 4.67723C1.15545 4.71414 1.09925 4.77014 1.06001 4.83907C1.02076 4.908 1 4.98719 1 5.06795C1 5.1487 1.02076 5.2279 1.06001 5.29682C1.09925 5.36575 1.15545 5.42175 1.22244 5.45866L8.02364 9.23079C8.16946 9.31153 8.33119 9.35367 8.4953 9.35367C8.65942 9.35367 8.82115 9.31153 8.96697 9.23079L15.7682 5.45866C15.835 5.42157 15.891 5.36551 15.9301 5.2966C15.9691 5.2277 15.9898 5.1486 15.9898 5.06795C15.9898 4.98729 15.9691 4.90819 15.9301 4.83929C15.891 4.77038 15.835 4.71432 15.7682 4.67723V4.67723Z" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M1.01074 8.81787L8.02379 12.445C8.16961 12.5257 8.33134 12.5679 8.49545 12.5679C8.65957 12.5679 8.8213 12.5257 8.96712 12.445L16.0001 8.81787" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            <path d="M1.01074 12.0322L8.02379 15.6594C8.16961 15.7401 8.33134 15.7822 8.49545 15.7822C8.65957 15.7822 8.8213 15.7401 8.96712 15.6594L16.0001 12.0322" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                       </svg>-->
    <!--                    </v-list-item-icon>-->
    <!--                    <v-list-item-content class="no-padding">-->
    <!--                        <v-list-item-title  class="d-flex mb-3 align-center font text-gray ">-->
    <!--                            My Plan Unfo-->
    <!--                        </v-list-item-title>-->
    <!--                    </v-list-item-content>-->
    <!--                </v-list-item>-->
    <!--                <v-divider></v-divider>-->

    <!--                 <v-list-group-->
    <!--                            :value="true"-->
    <!--                             :class="item == 'account-settings' ? 'pointer active' : 'pointer'"-->
    <!--                        >-->
    <!--                            <template v-slot:activator>-->
    <!--                            <svg   @click="activeItem('account-settings')" width="30" height="30" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
    <!--                                <path d="M7.96501 2.19798C8.09556 2.34292 8.25511 2.45881 8.43331 2.53814C8.61151 2.61746 8.80438 2.65845 8.99944 2.65845C9.19449 2.65845 9.38737 2.61746 9.56557 2.53814C9.74377 2.45881 9.90331 2.34292 10.0339 2.19798L10.7069 1.4594C10.8998 1.2459 11.154 1.09733 11.4347 1.03408C11.7153 0.970841 12.0087 0.996024 12.2745 1.10618C12.5403 1.21633 12.7655 1.40605 12.9192 1.64931C13.0729 1.89257 13.1475 2.17743 13.1329 2.46481L13.0824 3.46097C13.0726 3.6553 13.1036 3.84952 13.1735 4.03112C13.2433 4.21272 13.3504 4.37768 13.4879 4.51536C13.6254 4.65304 13.7901 4.7604 13.9716 4.83052C14.1531 4.90064 14.3472 4.93197 14.5415 4.92248L15.5375 4.87196C15.8247 4.8578 16.1092 4.93281 16.3521 5.0867C16.5949 5.24059 16.7843 5.46583 16.8941 5.73155C17.004 5.99728 17.029 6.29048 16.9657 6.57097C16.9024 6.85146 16.754 7.10552 16.5407 7.29832L15.7994 7.96717C15.6546 8.09793 15.5389 8.2576 15.4597 8.43587C15.3805 8.61414 15.3396 8.80704 15.3396 9.00211C15.3396 9.19719 15.3805 9.39009 15.4597 9.56836C15.5389 9.74663 15.6546 9.9063 15.7994 10.0371L16.5407 10.7059C16.7541 10.8988 16.9027 11.1531 16.9659 11.4338C17.0292 11.7145 17.004 12.0079 16.8938 12.2738C16.7837 12.5396 16.594 12.7648 16.3508 12.9185C16.1076 13.0722 15.8227 13.1469 15.5354 13.1323L14.5394 13.0817C14.3447 13.0717 14.15 13.1027 13.968 13.1727C13.786 13.2427 13.6207 13.3501 13.4828 13.488C13.345 13.6259 13.2376 13.7912 13.1676 13.9732C13.0976 14.1552 13.0667 14.3499 13.0767 14.5447L13.1272 15.5408C13.1399 15.8268 13.0644 16.1097 12.9107 16.3512C12.7571 16.5927 12.5329 16.781 12.2685 16.8906C12.0041 17.0002 11.7124 17.0257 11.433 16.9637C11.1537 16.9017 10.9001 16.7552 10.7069 16.5441L10.0374 15.8034C9.90675 15.6587 9.74717 15.5429 9.56898 15.4637C9.3908 15.3846 9.19798 15.3436 9.003 15.3436C8.80801 15.3436 8.61519 15.3846 8.43701 15.4637C8.25882 15.5429 8.09924 15.6587 7.96857 15.8034L7.29626 16.5441C7.10332 16.7562 6.84968 16.9036 6.56991 16.9663C6.29014 17.029 5.99786 17.0038 5.73291 16.8943C5.46795 16.7847 5.24323 16.5961 5.08936 16.3542C4.93549 16.1122 4.85998 15.8287 4.8731 15.5423L4.92433 14.5461C4.93434 14.3513 4.90337 14.1567 4.8334 13.9746C4.76344 13.7926 4.65604 13.6273 4.51817 13.4894C4.38029 13.3515 4.21501 13.2441 4.03301 13.1741C3.851 13.1041 3.65634 13.0732 3.46161 13.0832L2.4656 13.1337C2.17838 13.1487 1.89357 13.0744 1.65025 12.921C1.40694 12.7676 1.21706 12.5427 1.10667 12.2771C0.996293 12.0115 0.970825 11.7182 1.03377 11.4375C1.09671 11.1568 1.24497 10.9025 1.45821 10.7095L2.19881 10.0406C2.34355 9.90986 2.45926 9.75018 2.53845 9.57192C2.61764 9.39365 2.65855 9.20074 2.65855 9.00567C2.65855 8.8106 2.61764 8.6177 2.53845 8.43943C2.45926 8.26116 2.34355 8.10149 2.19881 7.97073L1.45821 7.29832C1.24567 7.1055 1.09785 6.85172 1.03497 6.5717C0.972097 6.29167 0.997222 5.99906 1.10692 5.73385C1.21661 5.46865 1.40552 5.24379 1.64782 5.09003C1.89012 4.93627 2.17399 4.86111 2.46062 4.87481L3.45663 4.92533C3.65173 4.93559 3.8468 4.90469 4.02918 4.83463C4.21156 4.76458 4.37717 4.65694 4.51524 4.51871C4.65332 4.38048 4.76078 4.21474 4.83065 4.03227C4.90051 3.8498 4.93122 3.65466 4.92077 3.45955L4.8731 2.46268C4.85966 2.17611 4.93495 1.89238 5.0887 1.65019C5.24245 1.40801 5.46717 1.21917 5.73219 1.10944C5.99722 0.999708 6.28964 0.974435 6.56955 1.03707C6.84947 1.0997 7.10325 1.24719 7.29626 1.4594L7.96501 2.19798Z" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                                <path d="M5.79785 9.00248C5.79785 9.85169 6.13515 10.6661 6.73554 11.2666C7.33593 11.8671 8.15024 12.2044 8.99932 12.2044C9.8484 12.2044 10.6627 11.8671 11.2631 11.2666C11.8635 10.6661 12.2008 9.85169 12.2008 9.00248C12.2008 8.15327 11.8635 7.33885 11.2631 6.73836C10.6627 6.13788 9.8484 5.80054 8.99932 5.80054C8.15024 5.80054 7.33593 6.13788 6.73554 6.73836C6.13515 7.33885 5.79785 8.15327 5.79785 9.00248V9.00248Z" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--                            </svg>-->
    <!--                            <v-list-item-title  @click="activeItem('account-settings')" class="ml-3 text-gray font">Settings</v-list-item-title>-->
    <!--                            </template>-->
    <!--                            <div class="ml-16 text-gray font">-->
    <!--                            <span class="pointer" @click="activeItem('account')" >-->
    <!--                                Account-->
    <!--                            </span>-->
    <!--                            <br>-->
    <!--                            <span class="pointer" @click="activeItem('users')" >-->
    <!--                                    Users-->
    <!--                            </span>-->
    <!--                            </div>-->
    <!--                </v-list-group>-->
    <!--        </v-navigation-drawer>-->
  </div>
</template>
<script>
export default {
  name: "EmployerSideBar",
  data() {
    return {
      miniVersion: true,
      item: "home",
      dialog: false,
      items: [
        {
          icon: "fas fa-home",
          title: "Home",
        },
        {
          icon: "fas fa-users",
          title: "Clients",
        },
        {
          icon: "fas fa-cog",
          title: "Settings",
        },
      ],
    };
  },
  props: {
    windowWidth: {
      type: Boolean,
    },
    mini: {
      type: Boolean,
    },
  },
  computed: {
    showMini() {
      return this.mini;
    },
    routeParams() {
      let route = "";
      if (this.$route.params.name) {
        route = this.$route.params.name.replace(/ /g, "%20");
      }
      return route;
    },
    watchActiveItem() {
      let item = "";
      if (this.$route.path.includes("/member/providers")) {
        item = "care";
      } else if (this.$route.path.includes("/member/visit-passes")) {
        item = "passes";
      } else if (this.$route.path.includes("/member/services")) {
        item = "connect";
      } else if (this.$route.path.includes("/member/visit-passes")) {
        item = "passes";
      } else if (this.$route.path.includes("/member/profile")) {
        item = "profile";
      }
      return item;
    },
  },
  created() {},

  watch: {
    activeItem: function () {
      return this.item;
    },
  },
  methods: {
    activeItem(tab) {
      // this.$store.commit('setBreadcrumbs', tab)
      if (tab == "home") {
        this.item = "home";
        if (this.$route.path != "/member/home") {
          this.$router.push("/member/home");
        }
      }
      if (tab == "care") {
        this.item = "care";
        if (this.$route.path != "/member/providers") {
          this.$router.push("/member/providers");
        }
      }
      if (tab == "connect") {
        this.item = "connect";
        if (this.$route.path != "/member/services") {
          this.$router.push("/member/services");
        }
      }

      if (tab == "passes") {
        this.item = "passes";
        if (this.$route.path != "/member/visit-passes") {
          this.$router.push("/member/visit-passes");
        }
      }
      if (tab == "profile") {
        this.item = "profile";
        if (this.$route.path != "/member/profile") {
          this.$router.push("/member/profile");
        }
      }
      if (!this.windowWidth) {
        this.$emit("closeSideBar");
      }
    },
  },
};
</script>

